import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=12dd6724&scoped=true&"
import script from "./lottery.vue?vue&type=script&lang=ts&"
export * from "./lottery.vue?vue&type=script&lang=ts&"
import style0 from "./lottery.vue?vue&type=style&index=0&id=12dd6724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd6724",
  null
  
)

export default component.exports